import React from 'react';
import PropTypes from 'prop-types';
import { RemoveScroll } from 'react-remove-scroll';

import useScreen from 'hooks/useScreen';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import useIsMobileUserAgent from 'hooks/useIsMobileUserAgent';
import useIsiPadUserAgent from 'hooks/useIsiPadUserAgent';
import DesktopBodyScrollLock from './DesktopBodyScrollLock';

const BodyScrollLock = ({ children, className = '', enabled = true }) => {
  const { isMobile } = useScreen();
  const isMobileUserAgent = useIsMobileUserAgent();
  const isiPadUserAgent = useIsiPadUserAgent();

  const shouldUseMobileScrollLocking =
    isMobile || isMobileUserAgent || isiPadUserAgent;

  if (shouldUseMobileScrollLocking) {
    return (
      <RemoveScroll
        className={className}
        enabled={enabled}
        removeScrollBar={false}
      >
        {children}
      </RemoveScroll>
    );
  }

  return (
    <DesktopBodyScrollLock className={className} enabled={enabled}>
      {children}
    </DesktopBodyScrollLock>
  );
};

BodyScrollLock.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  enabled: PropTypes.bool,
};

export default withBrowserOnly(BodyScrollLock);
